import { ReactElement, useEffect, useRef, useState } from "react"
import Player from "@vimeo/player"

import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog"

export function PromoVideoDialog({
  vimeoId,
  children,
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
  defaultOpen = false,
}: {
  vimeoId: number
  children: ReactElement
  open?: boolean
  onOpenChange?: (open: boolean) => void
  defaultOpen?: boolean
}) {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen)
  const isControlled = controlledOpen !== undefined
  const videoOpen = isControlled ? controlledOpen : uncontrolledOpen
  const [autoplay, setAutoplay] = useState(false)
  const setVideoOpen = (next: boolean) => {
    setAutoplay(next)
    if (!isControlled) setUncontrolledOpen(next)
    controlledOnOpenChange?.(next)
  }
  useEffect(() => {
    if (!videoOpen) setAutoplay(false)
  }, [videoOpen])

  useEffect(() => {
    setTimeout(() => {
      const iframe = iframeRef.current
      if (!iframe) return
      const player = new Player(iframe)
      const onVideoEnd = () => setVideoOpen(false)
      player.on("ended", onVideoEnd)
      return () => {
        player.off("ended", onVideoEnd)
      }
    })
  }, [videoOpen])

  return (
    <Dialog presentation="dialog" open={videoOpen} onOpenChange={setVideoOpen}>
      <DialogTrigger render={children} />
      <DialogContent size="full" closeVariant="primary" className="bg-black">
        <DialogTitle className="sr-only">Mindtrip video</DialogTitle>
        <iframe
          ref={iframeRef}
          src={`https://player.vimeo.com/video/${vimeoId}?autoplay=${autoplay ? 1 : 0}`}
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
          className="absolute inset-0 size-full"
          title="Mindtrip Product Promo"
        />
      </DialogContent>
    </Dialog>
  )
}
